export const userRoles = {
  SuperUser: 'SuperUser',
  Admin: 'Admin',
  User: 'User',
}
